module.exports = __webpack_public_path__ + "static/media/final.43f0dc89.png";